import React, { useEffect } from 'react';
import { useToast } from '../contexts/ToastContext';
import { useAppDispatch } from '../store/hooks';
import { logout } from '../features/auth/slices/auth.slice';

const DeactivatedAccountGuard: React.FC = () => {
  const { addToast } = useToast();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      const message: string = detail?.message || '';
      const isAdminAction = message.toLowerCase().includes('administrator');
      addToast({
        type: 'warning',
        title: isAdminAction ? 'Account deactivated by admin' : 'Account suspended',
        message: message || 'Your account has been deactivated. Please contact support for assistance.',
        duration: 6000,
      });
    };

    window.addEventListener('user:deactivated', handler);
    return () => window.removeEventListener('user:deactivated', handler);
  }, [addToast]);

  return null;
};

export default DeactivatedAccountGuard;
